import { z } from 'zod';

export const UserProfileSchema = z.object({
  name: z.string(),
  handle: z.string(),
  kycVerified: z.boolean(),
  /** Virtual paper-trading capital, in rupees. Never merged with real money. */
  virtualCapital: z.number(),
  /** Real-money payout wallet, in rupees. Legally gated — UI only until counsel. */
  payoutWallet: z.number(),
  /** Practice mode: no auth/paywall passed yet; PAPER badge shown in headers. */
  practiceMode: z.boolean(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;

export const JournalDaySchema = z.object({
  day: z.number(),
  label: z.string(), // "Tue 14 Jul"
  /** ISO calendar date (YYYY-MM-DD, IST session day) — the heatmap's axis.
   *  Optional: clients tolerate older servers that only sent the label. */
  date: z.string().optional(),
  trades: z.number(),
  instrument: z.string(),
  pnl: z.number(),
});
export type JournalDay = z.infer<typeof JournalDaySchema>;

export const JournalStatsSchema = z.object({
  equityCurve: z.array(z.number()),
  totalPnl: z.number(),
  winRatePct: z.number(),
  winCount: z.number(),
  tradeCount: z.number(),
  profitFactor: z.number(),
  avgWin: z.number(),
  avgLoss: z.number(),
  days: z.array(JournalDaySchema),
});
export type JournalStats = z.infer<typeof JournalStatsSchema>;
